import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { DASHBOARD_ROUTE } from "../../../../routes";
import authServices from "../../../../services/authServices";
import dataProvider from "../../../../services/dataProvider";
import { FRONT_DESK_FORM_LIST_ROUTE } from "../../dashboard-routes";
import SelfDeclaration from "../forms/bucket-1/common/self-declaration";
import FrontDeskFormGenerator from "./front-desk-form-generator";
import frontDeskFormMap from "./front-desk-form-map";
import axios from "axios";
import qs from "qs";
import { parseTasks } from "../../common/task-parser";
import AssociatedTask from "../../common/associated-task";

const FrontDeskForm = () => {
    let baseState = {
        formType: "",
        formTitle: "",
        nameOfPersonCompletingForm: "",
        dateOfFormCompletionInString: "",
        dateOfFormCompletionInMilliSeconds: 0,
        tncAgreed: false,
    };

    const location = useLocation();
    const history = useHistory();
    const [formSchema, setFormSchema] = useState(null);
    const [formState, setFormState] = useState(baseState);

    const [isLoading, setIsLoading] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [associatedTask, setAssociatedTask] = useState(null);
    const [completeTask, setCompleteTask] = useState(false);

    useEffect(() => {
        let formKey = location.state.formKey;

        if (formKey && frontDeskFormMap[formKey]) {
            if (location.state?.editMode === true) {
                setEditMode(true);
                let cleanFS = {};
                let fs = location.state.formState;
                Object.keys(fs).forEach((key) => {
                    if (frontDeskFormMap[formKey].fields[key]?.type === "date") {
                        cleanFS[key] = fs[key];
                    } else {
                        cleanFS[key] = fs[key];
                    }
                });

                cleanFS = {
                    ...cleanFS,
                    tncAgreed: fs["tncAgreed"] === "true" ? true : false,
                    dateOfFormCompletionInString: fs["dateOfFormCompletionInString"],
                };

                // console.log(cleanFS)
                setFormState(() => cleanFS);

                fetchTask(formKey);
            } else {
                setFormState((fs) => ({
                    ...fs,
                    formType: formKey,
                    formTitle: frontDeskFormMap[formKey].formTitle,
                }));
            }
            setFormSchema(frontDeskFormMap[formKey]);
        } else {
            history.replace(DASHBOARD_ROUTE + FRONT_DESK_FORM_LIST_ROUTE);
        }
    }, []);

    function fetchTask(formType) {
        setIsFetching(true);
        // console.log("FT",formType)
        var data = qs.stringify({
            formType,
        });
        var config = {
            method: "post",
            url: dataProvider.baseUrl + "forms-getAssociatedTask",
            headers: {
                token: authServices.getToken(),
                orgid: authServices.getOrgId(),
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                setIsFetching(false);
                // console.log("AT",response.data);
                if (response.data.status === "success") {
                    let task = response.data.message[0];
                    if (task) {
                        let parsedTask = parseTasks(task);
                        if (!isNaN(parsedTask.deadline)) {
                            let deadline = parsedTask.deadline * 1000;
                            if (deadline - Date.now() < 2629800000) {
                                //one month
                                setCompleteTask(true);
                            }
                        }
                        setAssociatedTask(parsedTask);
                        // console.log(task);
                    }
                }
            })
            .catch(function (error) {
                setIsFetching(false);
                console.error(error);
            });
    }

    // useEffect(() => {
    //     console.log("FS", formState);
    // }, [formState]);

    function handleSubmit(e) {
        e.preventDefault();
        // console.log("SUBMIT", formState);
        setIsLoading(true);
        setSuccessMsg("");
        setErrorMsg("");
        // var data = qs.stringify(formState);
        var data = new FormData();

        for (var key in formState) {
            if (formState[key]?.isLink === true && formState[key].link) {
                data.append(key, formState[key].link);
            } else {
                data.append(key, formState[key]);
            }
        }

        data.append("completeUpcomingTask", completeTask);

        var config = {
            method: "post",
            url: dataProvider.baseUrl + "forms-addFrontdeskData",
            headers: {
                token: authServices.getToken(),
                orgid: authServices.getOrgId(),
                "content-type": "multipart/form-data",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                if (response.data.status === "success") {
                    setSuccessMsg("Form Submitted Successfully");

                    // markTaskComplete()
                } else {
                    setErrorMsg("Something Went Wrong");
                }
                setIsLoading(false);
            })
            .catch(function (error) {
                console.error(error);
                setErrorMsg(error.message);
                setIsLoading(false);
            });
    }

    return (
        <div id="frontDeskForm">
            <div className="container-fluid p-0">
                <div className="card p-4 m-0 no-radius border-0 border-bottom">
                    <h5 className="m-0">{formState.formType && frontDeskFormMap[formState.formType].formTitle}</h5>
                </div>
            </div>

            {successMsg && !errorMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-success m-0" role="alert">
                        {successMsg}
                    </div>
                </div>
            )}

            {errorMsg && (
                <div className="container-fluid py-0 mt-3 px-3">
                    <div className="alert alert-danger m-0" role="alert">
                        {errorMsg}
                    </div>
                </div>
            )}

            {isFetching ? (
                <div className="container-fluid p-3">
                    <div className="card p-3">
                        <div className="">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="me-3">Fetching Form Data</div>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div>
                    <div className="container-fluid p-3">
                        <div className="card p-3">
                            <div className="d-flex justify-content-center">
                                <form className="w-100" style={{ maxWidth: "60rem" }} onSubmit={handleSubmit}>
                                    {formSchema !== null && (
                                        <FrontDeskFormGenerator
                                            formSchema={formSchema}
                                            formState={formState}
                                            setFormState={setFormState}
                                            onSubmit={handleSubmit}
                                            editMode={editMode}
                                        />
                                    )}

                                    {associatedTask && (
                                        <AssociatedTask
                                            completeTask={completeTask}
                                            setCompleteTask={setCompleteTask}
                                            task={associatedTask}
                                        />
                                    )}

                                    <SelfDeclaration
                                        setFormState={setFormState}
                                        formState={formState}
                                        isLoading={isLoading}
                                        editMode={editMode}
                                    />
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FrontDeskForm;
